const tabs = [
  {
    id: 0,
    tab: 'Tax Info',
  },
  {
    id: 1,
    tab: 'Owner Info',
  },
  {
    id: 2,
    tab: 'Comments',
  },
  {
    id: 3,
    tab: 'Adjustments',
  },
  {
    id: 4,
    tab: 'Mobile',
  },
  {
    id: 5,
    tab: 'History',
  },
  {
    id: 6,
    tab: 'Util',
  },
];

/**
 * Record-dialog tabs the sterilised "Tax Inquiry - view only" persona keeps: Tax Info, Owner
 * Info, Adjustments and Mobile. Comments and Util (Data Sync to Website) are dropped outright;
 * History goes with them because Owner/Address History is built out of category-3 comments.
 *
 * The tab headers (CRUDList's tabsList) and the tab bodies (TaxInquiryDialog's v-tab-items) are
 * matched by RENDER ORDER, not by id, so both sides must filter through this one function or the
 * wrong panel shows under the right header.
 */
const viewOnlyTabIds = [0, 1, 3, 4];

const visibleTabs = (isTaxViewOnly) => (
  isTaxViewOnly ? tabs.filter((t) => viewOnlyTabIds.includes(t.id)) : tabs
);

const isTabVisible = (id, isTaxViewOnly) => !isTaxViewOnly || viewOnlyTabIds.includes(id);

const pickListAndProtestTaxPaymentsTabs = [
  {
    id: 0,
    tab: 'Pick List',
  },
  {
    id: 1,
    tab: 'Protest Tax Payments',
  },
];

const exemptionsList = [
  {
    name: 'H',
    description: 'Homestead',
  },
  {
    name: 'V',
    description: 'Veteran',
  },
  {
    name: 'D',
    description: 'Disabled',
  },
];

const createOmitTabs = [
  {
    id: 0,
    tab: 'Tax Info',
  },
  {
    id: 1,
    tab: 'Owner Name and Address',
  },
  {
    id: 3,
    tab: 'Mobile',
  },
];

export {
  tabs, visibleTabs, isTabVisible, pickListAndProtestTaxPaymentsTabs, exemptionsList, createOmitTabs,
};
